import _debounce from 'lodash/debounce';
import _cloneDeep from 'lodash/cloneDeep';

import { cancelUserOrders, updateMemberPaid } from '@/api/orders';
import MenuCommonDialog from '@/components/Store/MenuCommonDialog/MenuCommonDialog.vue';
import bus from '@/utils/bus';
import {
  ORDER_STATUS,
  RECEIVING_STATUS,
  RECEIVING_STATUS_TEXT,
  SNACKBAR_TYPES,
} from '@/utils/constants';
import { formatPrice } from '@/utils/helper';

import PaidAll from '../PaidAll/PaidAll.vue';

export default {
  name: 'OrderMemberTable',
  components: {
    MenuCommonDialog,
    PaidAll,
  },
  props: {
    orderId: {
      required: true,
      type: Number,
    },
    orderStatus: {
      default: null,
      type: Number,
    },
    value: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      isCancelingOrder: false,
      members: [],
      rowInfos: {},
      showOnDeleteOrderDialog: false,
      showPaidAllConfirmDialog: false,
      toggleAllDetail: false,
    };
  },
  watch: {
    value(newValue) {
      this.members = _cloneDeep(newValue);
    },
  },
  computed: {
    allowCancel() {
      const statuses = [
        ORDER_STATUS.ENDED,
        ORDER_STATUS.ONGOING,
      ];
      return statuses.includes(this.orderStatus);
    },
    openedRowDetail() {
      return this.toggleAllDetail ? this.members.map((i) => i.id) : [];
    },
    orderedMembers() {
      return this.members?.map((member) => ({
        ...member,
        fullPaid: +member?.paid >= +member?.subtotal,
      }));
    },
    isAllDetailOpened() {
      return this.openedRowDetail.length === this.members.length;
    },
    receivingStatus() {
      return RECEIVING_STATUS;
    },
  },
  mounted() {
    this.members = _cloneDeep(this.value);
  },
  methods: {
    async onConfirmCancelOrder() {
      this.isCancelingOrder = true;
      try {
        const { orderId } = this.$route?.params || {};
        await cancelUserOrders({
          orderId,
          userId: this.rowInfos?.id,
        });
        this.onCloseDeleteOrderDialog();
        bus.$emit('GET_ORDER_INFOS');
      } catch (error) {
        const { message } = error;
        const errorMessage = message ? `（錯誤：${message}）` : '';

        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          title: '刪除訂單失敗',
          msg: `刪除訂單失敗，請稍後再試。${errorMessage}`,
        });
      } finally {
        this.isCancelingOrder = false;
      }
    },
    columnThAttrs() {
      return {
        class: 'text-xs',
      };
    },
    formatPrice,
    getOrderItemsText(items = []) {
      return items.map(({ entree: { name = '', options = [] } = {}, quantity = 0 }) => {
        const filteredOptions = options?.map(({ items: optionItems = [] }) => optionItems.map(({ name: itemName }) => itemName).join('、')) || [];
        const optionsText = filteredOptions.filter(Boolean).join('、');
        return optionsText ? `${name}（${optionsText}）*${quantity}` : `${name}*${quantity}`;
      }).join('、');
    },
    getReceivingStatusText(status) {
      return RECEIVING_STATUS_TEXT[status];
    },
    getTotalColor({ paid, subtotal }) {
      return +subtotal === +paid ? 'text-black' : 'text-pink-500';
    },
    itemRowClass(item) {
      if (this.openedRowDetail.includes(item.id)) {
        return 'member-table__row member-table__row--opened';
      }
      return 'member-table__row';
    },
    onCancelOrder(payload = {}) {
      this.rowInfos = payload || {};
      this.showOnDeleteOrderDialog = true;
    },
    onCloseDeleteOrderDialog() {
      this.rowInfos = {};
      this.showOnDeleteOrderDialog = false;
    },
    togglePickStatus(member) {
      const targetMember = this.members.find((m) => m.id === member.id);
      targetMember.picked = !targetMember.picked;
    },

    // eslint-disable-next-line func-names
    updatePaid: _debounce(async function (row, paid) {
      const targetMember = this.members?.find((m) => m.id === row.id) || {};

      targetMember.paid = +paid;
      if (+paid > +row.subtotal) {
        this.$snackbar({
          msg: '收款金額不可大於小計',
          type: SNACKBAR_TYPES.ERROR,
        });
        return;
      }

      this.$emit('input', this.members);
      const data = {
        member_id: row?.id,
        amount: +paid || 0,
      };
      try {
        await updateMemberPaid(this.orderId, data);
      } catch ({ message }) {
        const errorMessage = message ? `(${message})` : '';
        this.$snackbar({
          msg: `更新收款金額時時發生錯誤，請重試一次${errorMessage}`,
          type: SNACKBAR_TYPES.ERROR,
        });
      }
    }, 500),
    sortOptions(options) {
      return [...options].sort((a, b) => a.index - b.index);
    },
  },
};
